/* eslint-disable */
/* ==================================================
#Vendor script loader
#Image functions
#Recently viewed
#Load more / infinite load
#Predictive search
#Mobile search
#Site overlay
#Sidebar filter on collection pages
#Misc
#Quick shop
#Back to top button
#Newsletter popup
#Product Media Controls
#Plyr setup

/*============================================================================
  #Vendor script loader
==============================================================================*/

// Loads large vendor libraries on demand instead of shipping them to every
// visitor inside vendors.js. Each asset is fetched at most once; the cached
// promises survive InstantClick page changes because the JS context persists.
window.vendorScripts = {
  urls: {
    fancybox: "//elyqq.com/cdn/shop/t/29/assets/fancybox.js?v=52821751397815263621787601818",
    flickity: "//elyqq.com/cdn/shop/t/29/assets/flickity.js?v=3351824772421708881787601818"
  },
  styleUrls: {
    fancybox: "//elyqq.com/cdn/shop/t/29/assets/fancybox.css?v=19278034316635137701787601818"
  },
  promises: {},
  stylePromises: {},
  load: function(name) {
    if (!this.promises[name]) {
      var url = this.urls[name];
      this.promises[name] = new Promise(function(resolve, reject) {
        var script = document.createElement('script');
        script.src = url;
        script.setAttribute('data-no-instant', '');
        script.onload = function() { resolve(); };
        script.onerror = function() { reject(new Error('Failed to load ' + url)); };
        document.head.appendChild(script);
      });
    }
    return this.promises[name];
  },
  loadStyle: function(name) {
    if (!this.stylePromises[name]) {
      var url = this.styleUrls[name];
      this.stylePromises[name] = new Promise(function(resolve) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = url;
        link.onload = function() { resolve(); };
        // A missing stylesheet degrades the UI but shouldn't block it entirely
        link.onerror = function() {
          console.error('Failed to load ' + url);
          resolve();
        };
        document.head.appendChild(link);
      });
    }
    return this.stylePromises[name];
  }
};

// Resolves once fancybox's JS and CSS are loaded (fetched in parallel) and the
// theme defaults (defined in app.js) have been applied. All fancybox
// bindings/opens must go through this.
window.loadFancybox = function() {
  return Promise.all([
    window.vendorScripts.load('fancybox'),
    window.vendorScripts.loadStyle('fancybox')
  ]).then(function() {
    if (window.setupFancyboxDefaults) {
      window.setupFancyboxDefaults();
    }
  });
};

// Resolves once Flickity's JS is loaded and the theme's resize-on-image-load
// patch (defined in app.js) has been applied. All slider initialization must
// go through this. Flickity's CSS lives in the main stylesheet, so only the
// script is fetched on demand.
window.loadFlickity = function() {
  return window.vendorScripts.load('flickity').then(function() {
    if (window.setupFlickityPatch) {
      window.setupFlickityPatch();
    }
  });
};

/*============================================================================
  #Image functions
==============================================================================*/


window.usePageDots = window.PXUTheme.theme_settings.page_dots_enabled;

 window.imageFunctions = {
  zoom: function($image) {
    var $image = $image && $image[0] ? $image : $(event.target);
    var zoomSrc = $image.data('zoom-src');

    if (zoomSrc) {
      $image.wrap('<span class="zoom-container"></span>').css('display', 'block').parent().zoom({
        url: zoomSrc,
        touch: false,
        magnify: 1
      });
    }
  },
  linkGalleryAndCarousel: function($gallery, $carousel){

    $carousel.find('.gallery-cell:nth-child(1)').addClass('is-nav-selected');

    //EVENT - click on carousel item to slide gallery
    $carousel.on( 'click', '.gallery-cell', function() {
        var index = $(this).index();
        $carousel.find('.is-nav-selected').removeClass('is-nav-selected');
        $(this).addClass('is-nav-selected');
        $gallery.flickity( 'select', index );
    });

    //EVENT - update carousel based on gallery index
    $gallery.on( 'select.flickity', function() {
      var galleryData = $(this).data('flickity');
      if (galleryData){
        $carousel.find('.is-nav-selected').removeClass('is-nav-selected');
        $carousel.find('.gallery-cell:nth-child(' + (galleryData.selectedIndex + 1) + ')').addClass('is-nav-selected');
      }
    });
  },
  fullWidth: function(images, imageContainer){
    $(images).each(function(){
      var $image = $(this),
          alt = $image.attr('alt'),
          src = $image.attr('src');

      if (alt.indexOf("[") >= 0){

        //remove from description
        $image.remove();

        //find shortcode values and remove from alt
        var shortcodes = alt.match(/\[(.*?)\]/ig);
        alt = alt.replace(/\[(.*?)\]/ig, '');

        //remove brackets from shortcode to be used as classes
        var captionClass = $.map( shortcodes, function( value, index ) {
            value = value.replace(/[\[\]']+/g,'');
            return value;
        });

        //markup for caption

        var caption = [
            '<div class="position-' + (captionClass.length ? captionClass : 'center') + ' caption js-caption">',
              '<div class="caption-content caption-background-false align-' + (captionClass.length ? captionClass : 'center') + '">',
                '<p class="headline">' + alt + '</p>',
              '</div>',
            '</div>'
        ].join('');

        //image attributes added
        $image.attr({
          alt: alt,
          class: 'lazyload blur-up',
          src: src,
          dataSizes: 'auto'
        });

        var image = $image.prop('outerHTML')
        var banner =  '<div class="banner">' + image + caption + '</div>'

        $(imageContainer).append(banner);
      }
    })
  },
  showSecondaryImage: function(){
    if (window.PXUTheme.media_queries.large.matches) {
      $('.has-secondary-media-swap').off().on('mouseenter', function() {
        if (window.PXUTheme.theme_settings.product_form_style == 'select') {
          $(this).find('.product_gallery').toggleClass('secondary-media-hidden');
        }
        $(this).find('.image-element__wrap img').toggleClass('secondary-media-hidden');
        $(this).find('[data-html5-video]').toggleClass('secondary-media-hidden');
        $(this).find('.external-video__container').toggleClass('secondary-media-hidden');
        window.videoFeature.enableVideoOnHover($(this));
      });

      $('.has-secondary-media-swap').on('mouseleave', function() {
        if (window.PXUTheme.theme_settings.product_form_style == 'select') {
          $(this).find('.product_gallery').toggleClass('secondary-media-hidden');
        }
        $(this).find('.image-element__wrap img').toggleClass('secondary-media-hidden');
        $(this).find('[data-html5-video]').toggleClass('secondary-media-hidden');
        $(this).find('.external-video__container').toggleClass('secondary-media-hidden');
        window.videoFeature.enableVideoOnHover($(this));
      });
    }
  },
  //Fix for flickity issue on IOS, where you can't swipe through the slider
  flickityIosFix: function()  {
    var touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  }
}

/* ============================================================================
  #Recently viewed
============================================================================== */

window.recentlyViewed = {
  init() {
    let productHandle;
    let rvCookie;
    let rvProducts;
    let displayProducts;
    let rvProductArray;

    if ($('.js-product-section[data-rv-handle]').length) {
      productHandle = $('.js-product-section').data('rv-handle').toString();
      rvCookie = window.Cookies.get('recentlyViewed');
      rvProducts = window.recentlyViewed.getCookieProducts(rvCookie, productHandle);
    } else if ($('.recently-viewed__section').length) {
      rvCookie = window.Cookies.get('recentlyViewed');
      rvProducts = window.recentlyViewed.getCookieProducts(rvCookie, productHandle);
    } else if ($('.js-sidebar-recently-viewed').length) {
      rvCookie = window.Cookies.get('recentlyViewed');
      rvProducts = window.recentlyViewed.getCookieProducts(rvCookie, productHandle);
    }

    if (rvProducts) {
      rvProductArray = unescape(rvProducts).split(',');
    }

    if (productHandle) {
      if (!$.inArray(productHandle, rvProductArray) !== -1) {
        displayProducts = [];
        rvProductArray.unshift(productHandle);
        $.each(rvProductArray, (_i, el) => {
          if ($.inArray(el, displayProducts) === -1) displayProducts.push(el);
        });
      }

      window.recentlyViewed.setCookieProducts(displayProducts);
    } else {
      displayProducts = rvProductArray;
    }

    if ($('.recently-viewed__section').length) {
      const parent = '.recently-viewed__section';
      const recentlyViewedProductsLoaded = $(parent).data('recently-viewed-items-loaded');

      if (recentlyViewedProductsLoaded) {
        return false;
      }

      window.recentlyViewed.getProductInformation(parent, displayProducts, productHandle);
    } else if ($('.js-recently-viewed .rv-main').length) {
      const parent = '.js-recently-viewed';
      const recentlyViewedProductsLoaded = $(parent).data('recently-viewed-items-loaded');

      if (recentlyViewedProductsLoaded) {
        return false;
      }

      window.recentlyViewed.getProductInformation(parent, displayProducts, productHandle);
    }

    if ($('.sidebar .js-sidebar-recently-viewed').length) {
      const parent = '.sidebar .js-sidebar-recently-viewed';
      const recentlyViewedProductsLoaded = $(parent).data('recently-viewed-items-loaded');
      if (recentlyViewedProductsLoaded) {
        return false;
      }

      if (productHandle) {
        window.recentlyViewed.getProductInformation(parent, displayProducts, productHandle);
      } else {
        window.recentlyViewed.getProductInformation(parent, displayProducts);
      }
    }
  },
  getCookieProducts(rvCookie, productHandle) {
    if (!rvCookie && productHandle) {
      window.Cookies.set(
        'recentlyViewed',
        productHandle,
        {
          expires: 30,
          path: '/',
          sameSite: 'None',
          secure: true,
        },
      );
      rvCookie = window.Cookies.get('recentlyViewed');
    } else {
      rvCookie = window.Cookies.get('recentlyViewed');
    }

    return rvCookie;
  },
  setCookieProducts(rvProductArray) {
    window.Cookies.set(
      'recentlyViewed',
      escape(rvProductArray.join(',')),
      {
        expires: 30,
        path: '/',
        sameSite: 'None',
        secure: true,
      },
    );
  },
  getProductInformation(parent, displayProducts, productHandle) {
    // Add data-attribute 'recently-viewed-items-loaded="true" to parent container
    $(parent).attr('data-recently-viewed-items-loaded', 'true');

    if (productHandle) {
      displayProducts.splice($.inArray(productHandle, displayProducts), 1);
    }

    const productLimit = $(parent).data('visible-products');

    if (productLimit && displayProducts) {
      displayProducts = displayProducts.slice(0, productLimit);
    }

    $.each(displayProducts, (index, value) => {
      if (value) {
        $(parent).removeClass('hidden');

        $(parent).parents('.sidebar-block').show();

        $.ajax({
          type: 'GET',
          url: `${window.PXUTheme.routes.all_products_collection_url}/products/${value}?view=rv`,
          success(data) {
            const rvProduct = $(data).find('.js-recently-viewed-product');

            $(parent).find(`.rv-box-${index}`).append(rvProduct);

            // Call enable gallery function for product galleries
            $(`.rv-box-${index} [data-product-gallery]`).each((_, gallery) => {
              const $productGallery = $(gallery);
              window.productPage.enableGallery($productGallery);
            });

            // Convert currencies
            if (window.PXUTheme.currency.show_multiple_currencies) {
              window.currencyConverter.convertCurrencies();
            }

            // Run option selectors
            window.productPage.runOptionSelector($(`.rv-box-${index}`));

            // Initialize shopify payment buttons
            if (Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            // Hide <noscript> elements
            window.hideNoScript();

            // Initialize swatch toggler
            $('.swatch_options label').on('click', function() {
              window.quickShop.toggleSwatchImages($(this));
            });

            // Initialize the show secondary media on hover feature
            if (window.PXUTheme.theme_settings.collection_secondary_image) {
              window.imageFunctions.showSecondaryImage();
            }

            const $video = rvProduct.find('[data-html5-video] video, [data-youtube-video]');
            if ($video.length > 0) {
              window.videoFeature.setupPlayerForRecentlyViewedProducts(rvProduct.find('[data-html5-video] video, [data-youtube-video]'));
            }
          },
          error(x, t, m) {
            console.log(x);
            console.log(t);
            console.log(m);
          },
          dataType: 'html',
        });
      }

      if ($(parent).find('.rv-main').hasClass('js-rv-grid')) {
        if (displayProducts.length <= productLimit) {
          $('.js-rv-grid .thumbnail').eq(displayProducts.length).nextAll().addBack()
            .remove();
        } else {
          $('.js-rv-grid .thumbnail').eq(productLimit).nextAll().addBack()
            .remove();
        }
      }
    });
  }
};

/* ===============================================
  #Load more / infinite load
================================================== */

var enableLoadMoreProducts = function() {
  $('body').on('click', '.js-load-more a', function(e) {
    enableInfiniteScroll('[data-product-list]');
    e.stopPropagation();
    return false;
  });
}

var enableLoadMoreButton = function(parentClass) {

  var $grid = parentClass + '[data-load-more--grid]';
  var $gridItems = parentClass + ' [data-load-more--grid-item]';


  $('body').on('click', '[data-load-more]', function (e) {

    e.preventDefault();

    var $button = $(this);
    var url = $button.attr('href');

    loadNextPage(url, $button);
  });

  function loadNextPage(url, $button) {

    $.ajax({
      type: 'GET',
      dataType: 'html',
      url: url,
      beforeSend: function () {
        $button.addClass('is-loading');
        $('.loading-icon').addClass('loading-in-progress').css({
          'height': '40px',
          'width': '40px',
          'opacity': '1'
        });
      },
      success: function success(data) {
        $button.removeClass('is-loading');
        $('.loading-icon').removeClass('loading-in-progress').css({
          'height': '0',
          'width': '0',
          'opacity': '0'
        });

        const thumbnails = $(data).find($gridItems);

        var loadMoreButtonUrl = $(data).find('[data-load-more]').attr('href');

        $('[data-load-more]').attr('href', loadMoreButtonUrl);
        $($grid).first().append(thumbnails).append($('.js-load-more'));

        // Convert currencies
        if (window.PXUTheme.currency.show_multiple_currencies) {
          window.currencyConverter.convertCurrencies();
        }

        // Initialize the product page and run option selectors
        window.productPage.init();
        window.productPage.runOptionSelector(thumbnails);

        // Initialize shopify payment buttons
        if (Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        // Initialize the quick shop
        if (window.PXUTheme.theme_settings.quick_shop_enabled) {
          window.quickShop.init();
        }

        // Hide <noscript> elements
        window.hideNoScript();

        // Initialize video players
        window.videoFeature.init();

        // Initialize the show secondary media on hover feature
        if (window.PXUTheme.theme_settings.collection_secondary_image) {
          window.imageFunctions.showSecondaryImage();
        }

        // When there are no additional pages, hide load more button
        if (typeof loadMoreButtonUrl == 'undefined') {
          $('[data-load-more]').addClass('is-hidden');
        }
      },
      error: function (x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(location.protocol + '//' + location.host + filterURL);
      }
    });
  }
}

var enableInfiniteScroll = function(parentClass) {
  if ($(parentClass).length) {
    var infiniteScroll = new Waypoint.Infinite({
      element: $(parentClass)[0],
      items: parentClass,
      more: '[data-load-more]',
      loadingClass: 'loading-in-progress',
      onBeforePageLoad: function() {
        $('.js-load-more').hide();
      },
      onAfterPageLoad: function(data) {
        const $gridItems = $(`${parentClass} [data-load-more--grid-item]`);
        const thumbnails = $(data).find($gridItems);

        $(`${parentClass} > ${parentClass} .thumbnail`).unwrap(parentClass);

        // Convert currencies
        if (window.PXUTheme.currency.show_multiple_currencies) {
          window.currencyConverter.convertCurrencies();
        }

        // Initialize the product page and run option selectors
        window.productPage.init();
        window.productPage.runOptionSelector(thumbnails);

        // Initialize shopify payment buttons
        if (Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        // Initialize the quick shop
        if (window.PXUTheme.theme_settings.quick_shop_enabled) {
          window.quickShop.init();
        }

        // Hide <noscript> elements
        window.hideNoScript();

        // Initialize video players
        window.videoFeature.init();

        // Initialize the show secondary media on hover feature
        if (window.PXUTheme.theme_settings.collection_secondary_image) {
          window.imageFunctions.showSecondaryImage();
        }

        // Refresh waypoints
        Waypoint.refreshAll();
      }
    })
  }
}

window.hideNoScript = function(){
  // Used to ensure noscript elements are hidden when JS is present.
  $('.image__container .noscript').addClass('hidden');
}

/*============================================================================
  #Predictive search
==============================================================================*/

window.predictiveSearch = {
  init() {
    this.events = new EventHandler();
    this.forms = document.querySelectorAll('[data-autocomplete-true]');

    this.forms.forEach(form => {
      const input = form.querySelector('[data-search-input]');
      const results = form.querySelector('[data-predictive-search-results]');
      const resultsContainer = form.querySelector('[data-predictive-search]');
      const animation = window.animations.transition({ el: resultsContainer });

      this.events.register(form, 'submit', e => this._onSubmit(e, input));
      this.events.register(window, 'resize', debounce(() => this._onResize(resultsContainer), 250));
      this.events.register(window, 'keyup', e => this._onKeyUp(e, form, input, animation));
      this.events.register(input, 'focus', () => this._onFocus(form, input, results, resultsContainer, animation));
      this.events.register(resultsContainer, 'focusout', (e) => this._onFocusOut(e, form, animation));
      this.events.register(input, 'input', debounce(() => this._onChange(form, input, results, resultsContainer, animation), 250));

      this.events.register(document.body, 'click', e => {
        if (form.classList.contains('search-form--active') && !form.contains(e.target)) {
          this._close(form, animation);
        }
      });
    });
  },
  _onSubmit(e, input) {
    // Prevent empty form submissions
    if (this._getQuery(input).length === 0) e.preventDefault();
  },
  _onResize(resultsContainer) {
    this._resizeSearchResults(resultsContainer);
  },
  _onKeyUp(e, form, input, animation) {
    if (e.code === 'Escape') {
      input.value = '';

      this._close(form, animation);
    }
  },
  _onFocus(form, input, results, resultsContainer, animation) {
    const term = this._getQuery(input);

    if (term.length === 0) return;

    this._fetchResults(term, form, results, resultsContainer);
    this._open(form, resultsContainer, animation);
  },
  _onFocusOut(e, form, animation) {
    if (e.target.matches('[data-search-button]')) {
      this._close(form, animation);
    }
  },
  _onChange(form, input, results, resultsContainer, animation) {
    const term = this._getQuery(input);

    if (term.length === 0) {
      this._close(form, animation);
      return;
    }

    this._fetchResults(term, form, results, resultsContainer);
    this._open(form, resultsContainer, animation);
  },
  _getQuery(input) {
    return input.value.trim();
  },
  _open(form, resultsContainer, animation) {
    form.classList.add('search-form--active');

    if (!window.PXUTheme.media_queries.medium.matches) {
      document.body.classList.add('scroll-locked');
    }

    animation.animateTo('open');
    this._resizeSearchResults(resultsContainer);
  },
  _close(form, animation) {
    form.classList.remove('search-form--active');

    if (!window.PXUTheme.media_queries.medium.matches) {
      document.body.classList.remove('scroll-locked');
    }

    animation.animateTo('closed');
  },
  _fetchResults(term, form, results, resultsContainer) {
    const resourceType = form.classList.contains('search-form--blog') ? '&resources[type]=article' : '';

    resultsContainer.setAttribute('data-loading', 'true');

    fetch(`${window.PXUTheme.routes.predictive_search_url}?q=${encodeURIComponent(term)}${resourceType}&section_id=predictive-search`)
      .then(response => {
        if (!response.ok) {
          const error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then(text => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this._renderResults(resultsMarkup, results, resultsContainer);
      })
      .catch(error => {
        throw error;
      });
  },
  _renderResults(resultsMarkup, results, resultsContainer) {
    resultsContainer.setAttribute('data-loading', 'false');
    results.innerHTML = resultsMarkup;
  },
  _resizeSearchResults(resultsContainer) {
    const offset = 30;
    const position = resultsContainer.parentNode.getBoundingClientRect();
    const maxHeight = window.innerHeight - position.bottom - offset;

    resultsContainer.style.setProperty('--search-results-max-height', `${maxHeight}px`);
  }
}

/*============================================================================
  #Mobile search
==============================================================================*/

window.mobileSearch = {
  init() {
    this.events = new EventHandler();
    this.el = document.querySelector('[data-mobile-search]');
    this.closeEl = this.el.querySelector('[data-mobile-search-close]');
    this.animation = window.animations.transition({ el: this.el, state: 'closed' });

    this.events.register(this.closeEl, 'click', () => this.close());

    this.closed = true;
  },
  open() {
    if (this.closed) {
      this.animation.animateTo('open');
      window.siteOverlay.open();
      this.closed = false;
    }
  },
  close() {
    if (!this.closed) {
      this.animation.animateTo('closed');
      window.siteOverlay.close();
      this.closed = true;
    }
  },
  isClosed() {
    return this.closed;
  }
}

/*============================================================================
  #Site overlay
==============================================================================*/

window.siteOverlay = {
  init() {
    this.events = new EventHandler();
    this.el = document.querySelector('[data-site-overlay]');
    this.animation = window.animations.transition({ el: this.el, state: 'closed' });

    this.events.register(this.el, 'click', () => this.close());

    this.closed = true;
  },
  open() {
    if (this.closed) {
      document.body.classList.add('scroll-locked');
      this.animation.animateTo('open');
      this.closed = false;
    }
  },
  close() {
    if (!this.closed && window.PXUTheme.media_queries.medium.matches) {
      document.body.classList.remove('scroll-locked');
      this.animation.animateTo('closed');
      this.closed = true;

      if (!window.mobileSearch.isClosed()) {
        window.mobileSearch.close();
      }
    }
  },
  isClosed() {
    return this.closed;
  }
}

/*============================================================================
  #Sidebar filter on collection pages
==============================================================================*/

window.collectionSidebarFilter = {
  init: function(){
    const openActiveFilters = () => {
      const sidebar = document.querySelector('[data-sidebar]');

      if (!sidebar) return;

      const sidebarBlocks = sidebar.querySelectorAll('[data-sidebar-block]');

      if (!window.PXUTheme.media_queries.medium.matches) {
        sidebarBlocks.forEach(block => {
          if (block.querySelector('[data-active-legacy-filter]')) {
            block.open = true;
          }
        });
      }
    }

    openActiveFilters();

    $('.sidebar-block:empty').prev().css('border-bottom', 'none');

    //Will reload recently viewed if present
    window.recentlyViewed.init();
  }
}

window.sidebarAccordions = {
  init: function() {
    const sidebar = document.querySelector('[data-sidebar]');

    if (!sidebar) return;

    const sidebarBlocks = sidebar.querySelectorAll('[data-sidebar-block]');
    const facetedFilterForm = sidebar.querySelector('[data-faceted-filter-form]');

    const allowToggleOnDesktop = sidebar.dataset.sidebarAllowToggle === 'true';

    const closeAll = () => sidebarBlocks.forEach(block => { block.open = false; });
    const openAll = () => sidebarBlocks.forEach(block => { block.open = true; });

    let wasMobileLastResize = false;

    const setState = () => {
      if (window.PXUTheme.media_queries.medium.matches) {
        if (!wasMobileLastResize) {
          closeAll();
        }
        wasMobileLastResize = true;
      } else {
        if (!allowToggleOnDesktop) {
          openAll();
        }
        wasMobileLastResize = false;
      }
    };

    setState();

    window.addEventListener('resize', setState);

    // Faceted filtering

    if (facetedFilterForm) {
      // Submit the faceted filtering form when selecting a checkbox
      facetedFilterForm.addEventListener('keypress', e => {
        if (e.target.classList.contains('faceted-filter-group-display__list-item-input')) {
          if (event.keyCode == 13) {
            if (e.target.checked) {
              e.target.checked = false;
            } else {
              e.target.checked = true;
            }
          }
        }
      });

      const sortByEl = document.querySelector('[data-sort-by]');

      facetedFilterForm.addEventListener('change', e => {
        if (e.target.type == 'number') return;
        if (sortByEl) {
          const sortValue = sortByEl.value;
          // Create new formData, set the query string, and redirect
          const formData = new FormData(facetedFilterForm);
          const queryString = new URLSearchParams(formData);
          queryString.set('sort_by', sortValue);
          window.location.search = queryString;
        } else {
          // Submit the faceted filtering form
          facetedFilterForm.submit();
        }
      });
    }

    const setOpenHeight = el => {
      el.style.setProperty('--open-height', `${el.scrollHeight}px`);
    };

    sidebarBlocks.forEach(block => {
      const summary = block.querySelector('summary');
      if (!summary) return;

      const transition = window.animations.transition({
        el: block,
        state: block.open ? 'open' : 'closed',
        stateAttribute: 'data-sidebar-block-state',
        stateChangeAttribute: 'data-sidebar-block-animation'
      });

      summary.addEventListener('click', e => {
        e.preventDefault();

        if (!window.PXUTheme.media_queries.medium.matches && !allowToggleOnDesktop) return;

        const { height: closedHeight } = summary.getBoundingClientRect();
        block.style.setProperty('--closed-height', `${closedHeight}px`);

        if (block.open) {
          block.style.setProperty('--open-height', `${block.scrollHeight}px`);
          transition.animateTo('closed').then(() => { block.open = false; });
        } else {
          block.open = true;
          transition.animateTo('open', {
            onStart: () => {
              block.style.setProperty('--open-height', `${block.scrollHeight}px`)
            }
          });
        }
      })
    })
  },
}

/*============================================================================
  #Misc
==============================================================================*/
if (window.PXUTheme.theme_settings.slideshow_arrow_size == 'bold'){
  window.arrowSize = {
    x0: 10,
    x1: 40, y1: 50,
    x2: 80, y2: 50,
    x3: 50
  }
  window.svgArrowSizeLeft = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 40,100 L 80,100 L 50,50  L 80,0 L 40,0 Z" class="arrow"></path></svg>'
  window.svgArrowSizeRight = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 40,100 L 80,100 L 50,50  L 80,0 L 40,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>'
} else if (window.PXUTheme.theme_settings.slideshow_arrow_size == 'light'){
  window.arrowSize = {
    x0: 10,
    x1: 60, y1: 50,
    x2: 62, y2: 40,
    x3: 22
  }
  window.svgArrowSizeLeft = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow"></path></svg>'
  window.svgArrowSizeRight = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>'
} else if (window.PXUTheme.theme_settings.slideshow_arrow_size == 'regular'){
  window.arrowSize = {
    x0: 10,
    x1: 60, y1: 50,
    x2: 70, y2: 40,
    x3: 30
  }
  window.svgArrowSizeLeft = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>'
  window.svgArrowSizeRight = '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>'
}

window.isScreenSizeLarge = function isScreenSizeLarge() {
  if (window.matchMedia( "(min-width: 1024px)" ).matches) {
    return true;
  }
}

window.utils = {
  createAccordion: function(container, tab, content){
    var $container = $(container);
    var $tab = $(container).find(tab);
    var $content = $(container).find(content);
    var specificTab = container + ' ' + tab;

    //Check to see if need to rearrange product tabs to create accordion (backwards compatible)
    if (container.indexOf(".accordion-tabs") >= 0){
      var rearrangedTabs = $.map($tab, function(v, i) { return [v, $content[i]]; });
      $container.empty();

      $.each(rearrangedTabs, function (index, value) {
        $container.append(this);
      });

      $content.removeClass('active');
      $container.find('.active').next().slideToggle();

      tab = container + '> a';
    }

    $(container).children('a').each(function(i, tab) {
      var tab = $(this);
      var tabValue = tab.attr('href'); //get tab id
      tab.attr('data-tab-value', tabValue); //set tab id in data attribute
      tab.removeAttr("href"); //remove href (to prevent url hash update)
    });

    $(container).find(tab + '.active').next().slideToggle();
    $(specificTab).on('click', function(e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).next().slideToggle();
    });
  },
  mobileAccordion: function(container, tab) {
    $container = $(container);

    $tab = $(container).find(tab)
      .filter((_, el) => {
        const href = el.getAttribute('href');
        // `href === null` check is for disclosure links such as language/currency selectors.
        // Checking `href === '#'` won't work if there's a locale code (eg. `/fr#`).
        return !href || href === '/' || href.includes('#');
      });

    $(tab + '.active').next().slideToggle();

    $tab.on('click', function(e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).next().slideToggle();
    });
  },
  mobileParentActiveAccordion: function(container, tab) {
    $container = $(container);

    $tab = $(container).find(tab)
      .filter((_, el) => {
        const href = el.parentNode.getAttribute('href');
        return href !== '' && href !== '/' && !href.includes('#');
      });

    $(tab + '.active').parent().next().slideToggle();

    $tab.on('click', function(e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).parent().next().slideToggle();
    });
  },
  initializeTabs: function(){
    $('ul.tabs > li > a').attr('data-no-instant', true);
    $('body').on('click', 'ul.tabs > li > a', function(e) {
      e.preventDefault();
      var contentLocation = $(this).attr('href');
      if(contentLocation.charAt(0)=="#") {
        $('ul.tabs > li > a.active').removeClass('active');
        $(this).addClass('active');
        $(this).parents('ul.tabs').next().find(contentLocation).show().css({'display': 'block'}).addClass('active').siblings().hide().removeClass('active');
      }
    });
  },
  scrollToTop: function(element, height){
    // Check if height argument is present
    if(height != undefined) {
      $('html, body').animate({
        scrollTop: $(element).offset().top - height
      }, 1000);
    } else {
      $('html, body').animate({
        scrollTop: $(element).offset().top
      }, 1000);
    }
  },
  initializeSectionWrapper: function(){
    const firstSection = document.querySelector('.section-wrapper .shopify-section');

    if (!firstSection) return;

    window.navigationDesktopManager.initAll();

    if (firstSection.classList.contains('under-menu') && firstSection.querySelector('.full-width--true')) {
      if (!$('.header').hasClass('header-background--solid')) {
        $('.header').parent().addClass('feature_image');
        $('.header').addClass('is-absolute');
      }
      // Show the secondary logo
      if ($('.feature_image').hasClass('secondary_logo--true')){
        $('.secondary_logo--true').find('.secondary_logo').show();
        $('.secondary_logo--true').find('.primary_logo').hide();
      }
      window.headerFader.updateShouldFade(true);
    } else {
      $('.feature_image').removeClass('feature_image');
      $('.header.is-absolute').removeClass('is-absolute');
      // Hide the secondary logo
      if (!$('header.feature_image').hasClass('secondary_logo--true')){
        $('.secondary_logo--true').find('.secondary_logo').hide();
        $('.secondary_logo--true').find('.primary_logo').show();
      }
      window.headerFader.updateShouldFade(false);
    }
  },
  enableDisclosure: function() {

    var $disclosure = $('[data-disclosure]');
    var $toggle = $('[data-disclosure-toggle]');
    var $disclosureWrap = $('.disclosure__list-wrap');

    //Check if current opened menu is offscreen
    function checkOffScreen($openedToggle) {
      const el = $openedToggle.siblings('.disclosure__list-wrap')[0];
      const rect = el.getBoundingClientRect();

      if (rect.right > window.innerWidth) {
        $openedToggle.siblings('.disclosure__list-wrap').addClass('disclosure--left');
      }
    }

    function closeDisclosures(ignoreTarget, currentTarget) {
      if(ignoreTarget === true) {
        $toggle.not(currentTarget).removeClass('is-clicked');
        $toggle.not(currentTarget).attr('aria-expanded', 'false');
      } else {
        $toggle.removeClass('is-clicked');
        $toggle.attr('aria-expanded', 'false');
      }

      $disclosureWrap.removeClass('disclosure--left');
    }

    //Close menus on ESC
    $('body').on('keyup', function(e) {
      if(e.which == '27') {
        closeDisclosures();
      }
    });

    //Close menus on hoverout
    $disclosure.on('mouseleave', function(e) {
      closeDisclosures();
    });

    //On click/focus event for toggling options
    $toggle.on('mouseenter focus', function(e) {
      //Close all other menus
      closeDisclosures(true, this);

      var $target = $(e.currentTarget);
      $target.attr('aria-expanded', 'true').addClass('is-clicked');
      checkOffScreen($target);
    });

    //When tabbing through, close dropdown when tabbing out of dropdown
    $('.disclosure__button').on('focusout', function(e) {
      //Close all other menus
      if(!$(e.relatedTarget).hasClass('disclosure__button') || $(e.relatedTarget).hasClass('disclosure__toggle')) {
        closeDisclosures();
      }
    });

    //Mobile toggle logic
    $toggle.on('touchstart', function(e) {
      if (window.PXUTheme.media_queries.medium.matches || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        var $target = $(e.currentTarget);

        closeDisclosures(true, this);

        if(!$target.hasClass('is-clicked')) {
          $target.attr('aria-expanded', 'true').addClass('is-clicked');
          checkOffScreen($target);
        } else {
          $target.attr('aria-expanded', 'false').removeClass('is-clicked');
          $disclosureWrap.removeClass('disclosure--left');
        }
      }
    })

  },
  addImageDimension: function(imageUrl, size) {
    var insertPosition = imageUrl.lastIndexOf(".");
    return imageUrl.substring(0, insertPosition) + size + imageUrl.substring(insertPosition);
  },
  unload: function($target){
    $('[data-disclosure]').off();
    $('[data-disclosure-toggle]').off();
  }
}

window.sliderBlock = {
  select: function(blockId, $parentSection){
    var $blocks = $parentSection.find('.gallery-cell');
    var blockIdsArray = $blocks.map(function() {
      return String($(this).data('block-id'));
    });

    var $slider = $parentSection.find('[data-slider-id]');
    var settings = {
      slideshowTextAnimation: $slider.data('slideshow-text-animation')
    }
    var flkty = $slider.data('flickity');

    // Flickity loads on demand; nothing to select if the slider isn't built yet
    if (!flkty) {
      return;
    }

    $slider.flickity('pausePlayer');

    for(var i = 0; i < blockIdsArray.length; i++){
      if(blockIdsArray[i] === blockId){
        var currentSlide = i;
        if (currentSlide !== flkty.selectedIndex){
          $slider.flickity( 'select', parseInt(currentSlide), false, true);
        }
      }
    }
  },
  deselect: function($parentSection){
    var $slider = $parentSection.find('.flexslider').data('flexslider');
    if($slider) {
      $slider.flickity('unpausePlayer');
    }
  }
}

/*============================================================================
  #Quick shop
==============================================================================*/

var globalQuickShopProduct;

window.quickShop = {
  init: function(){

    //EVENT - click on quick-shop
    $('body').on('click', '.js-quick-shop-link', e => {
      e.preventDefault();

      const $currentTarget = $(e.currentTarget);

      window.productPage
        .loadQuickshop($currentTarget.data('url'))
        .then(data => {
          if (!data) { return; }
          const html = data.html;
          $('.js-quick-shop').html(html.content);

          if (!$('.fancybox-active').length) {
            window.loadFancybox().then(() => {
              $.fancybox.open($('.js-quick-shop'), {
                baseClass: `quick-shop__lightbox product-${$currentTarget.data('id')}`,
                hash: false,
                infobar : false,
                toolbar: false,
                loop: false,
                smallBtn : true,
                video: {
                  autoStart: false
                },
                touch: false,
                mobile: {
                  preventCaptionOverlap: false,
                  toolbar: true,
                  buttons: [
                    "close"
                  ]
                },
                beforeLoad: () => {
                  window.productPage.init();
                  window.productPage.runOptionSelector($('.js-quick-shop'));
                  window.accordion.init();
                  videoFeature.setupVideoPlayer();
                  productMedia.setupMedia();
                  utils.initializeTabs();
                  productPage.productSwatches();

                  if (Shopify.PaymentButton) {
                    Shopify.PaymentButton.init();
                  }
                },
                afterShow: (_e, instance) => {
                  // Use unique identifier for the product gallery
                  const { src } = instance;
                  const $quickshop = $(src).find('.quick-shop');

                  $quickshop.addClass('quick-shop--loaded');
                  $quickshop.addClass('content-loaded');
                },
                beforeClose: (_e, instance) => {
                  // Use unique identifier for the product gallery
                  const { src } = instance;
                  const $quickshop = $(src).find('.quick-shop');

                  $quickshop.removeClass('quick-shop--loaded');
                  $quickshop.removeClass('content-loaded');
                }
              });
            });
          }
        }).catch(error => console.error(error))
    });

    $('.swatch_options label').on('click', function() {
      window.quickShop.toggleSwatchImages($(this));
    });
  },
  toggleSwatchImages: function(swatchInput) {
    var swatchImageID = $(swatchInput).data('image');
    var $quickShopElement = $(swatchInput).parents('.thumbnail').find('.image__container img');

    $quickShopElement.attr('src', swatchImageID);
    $quickShopElement.attr('srcset', swatchImageID);
  }
}

/*============================================================================
  #Back to top button
==============================================================================*/

window.back_to_top_button = {
  init() {
    this.el = document.querySelector('[data-back-to-top]');
    this.label = this.el.querySelector('.back-to-top__button-label');
    this.events = new EventHandler();
    this.buttonAnimation = window.animations.transition({ el: this.el });
    this.labelAnimation = window.animations.transition({ el: this.label, state: 'hidden' });
    this.scrollThreshold = 0.3;
    this.events.register(this.el, 'click', () => this._scrollToTop());
    this.events.register(this.el, 'mouseenter', () => this._onHover());
    this.events.register(this.el, 'mouseleave', () => this._onHoverEnd());
    this.events.register(window, 'scroll', debounce(() => this._onScroll(), 100, true));
  },
  get scrollPosition() {
    return window.scrollY / (document.body.offsetHeight - window.innerHeight);
  },
  _onScroll() {
    if (window.PXUTheme.media_queries.medium.matches) return;

    if (this.scrollPosition >= this.scrollThreshold) {
      this.buttonAnimation.animateTo('visible');
    } else {
      this.buttonAnimation.animateTo('hidden');
    }
  },
  _onHover() {
    if (window.PXUTheme.media_queries.mobile_and_tablet.matches) return;
    this.labelAnimation.animateTo('visible', {
      onStart: ({ el }) => {
        // When this function is called, element is `display: block; width: 0;`
        // but the wrapper's scrollWidth is the width we want to transition to
        const { scrollWidth } = el;

        // Add 8px to the width to create padding between the text and the chevron
        // We add this space here because adding padding via CSS causes a 'stepped'
        // animation effect due to the way browsers calculate visible width
        const adjustedScrollWidth = parseInt(scrollWidth, 10) + 8;

        el.style.setProperty('--open-width', `${adjustedScrollWidth}px`);
      },
    });
  },
  _onHoverEnd() {
    if (window.PXUTheme.media_queries.mobile_and_tablet.matches) return;
    this.labelAnimation.animateTo('hidden');
  },
  _scrollToTop() {
    document.activeElement.blur();
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
}

/*============================================================================
  #Newsletter Popup
==============================================================================*/

window.newsletter_popup = {
  init: function(){
    var popup = window.Cookies.get('popup');
    var newsletter_popup_days = parseInt(window.PXUTheme.theme_settings.newsletter_popup_days);
    var cookie_enabled = newsletter_popup_days != 0 ? true : false;
    if (cookie_enabled && popup == 'open') {
      return false;
    } else {
      window.newsletter_popup.open();
    }
    if (cookie_enabled) {
      window.Cookies.set('popup', 'open', { expires: newsletter_popup_days, path: '', domain: '', sameSite: 'None', secure: true });
    }
  },
  open: function(){
    var newsletter_popup_seconds = parseInt(window.PXUTheme.theme_settings.newsletter_popup_seconds);

    if (window.PXUTheme.theme_settings.newsletter_popup_mobile || window.PXUTheme.media_queries.large.matches) {
      setTimeout( function() {
        window.loadFancybox().then(function() {
          $.fancybox.open($('.js-newsletter-popup'), {
            baseClass: 'newsletter__lightbox',
            hash: false,
            infobar : false,
            toolbar: false,
            loop: true,
            smallBtn : true,
            mobile: {
              preventCaptionOverlap: false,
              toolbar: true,
              buttons: [
                "close"
              ]
            }
          });
        });
      },
      newsletter_popup_seconds * 1000);
    }
  }
}

/*============================================================================
  #Product media controls
==============================================================================*/

window.productMedia = {
  models: [],
  setupMedia: function() {
    var config = {
      // Default control list
      controls: [
        'zoom-in',
        'zoom-out',
        'fullscreen'
      ],
      focusOnPlay: false
    }

    $($('model-viewer', $('.js-product-gallery, .js-gallery-modal'))).each(function(index, model) {
      model = new Shopify.ModelViewerUI(model, config);
      window.productMedia.models.push(model)
    })

    $('.product-gallery__model model-viewer').on('mousedown',function(){
      window.productMedia.hideModelIcon(this);
    })
  },
  showModelIcon: function(slide) {
    $(slide).find('.button--poster, .model-icon-button-control').show();
  },
  hideModelIcon: function(slide) {
    $(slide).find('.button--poster, .model-icon-button-control').hide();
  }
}

/*============================================================================
  #Plyr setup
==============================================================================*/

window.videoEl = {
  playButtonIcon:'<button type="button" class="plyr__control plyr__control--overlaid" aria-label="Play, {title}" data-plyr="play"><svg class="play-icon-button-control" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23 20V40L39 29.4248L23 20Z" fill="#323232"/></svg><span class="plyr__sr-only">Play</span></button>',
  playButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Play, {title}" data-plyr="play"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Pause</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span></button>',
  muteButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Mute" data-plyr="mute"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span></button>',
  progressInput: '<div class="plyr__controls__item plyr__progress__container"><div class="plyr__progress"><input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek"><progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress><span role="tooltip" class="plyr__tooltip">00:00</span></div></div>',
  volume: '<div class="plyr__controls__item plyr__volume"><input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume"></div>',
  fullscreen: '<button type="button" class="plyr__controls__item plyr__control" data-plyr="fullscreen"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span></button>'
}

window.videoControls = window.videoEl.playButtonIcon + '<div class="plyr__controls">' + window.videoEl.playButton + window.videoEl.progressInput + window.videoEl.muteButton + videoEl.volume + window.videoEl.fullscreen + '</div>';
window.globalVideoPlayers = [];
window.videoPlayers = [];
window.videosInRecommendedProductsPlayer;

window.videoFeature = {
  init: function() {

    this.setupVideoPlayer();
    this.setupRecommendedVideoPlayer();

  },
  setupVideoPlayer: function() {
    var productVideos = document.querySelectorAll('[data-html5-video] video, [data-youtube-video]');

    var setupVideoPlayers = Plyr.setup(productVideos, {
      controls: window.videoControls,
      ratio: this.aspect_ratio,
      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true
      },
      storage: {
        enabled: false
      }
    });

    // Moves players into global array so that we can target them for play/pause on global level
    if (window.globalVideoPlayers) {
      $.each(setupVideoPlayers, function(index, player) {
        window.globalVideoPlayers.push(player);
      })
    }

    var videoLooping = $('[data-video-loop]').data('video-loop') || false;
    $.each(setupVideoPlayers, function(index, player) {
      player.loop = videoLooping;
      window.videoPlayers.push(player);
    });

    this.setupListeners();
  },
  setupPlayerForRecentlyViewedProducts: function(video) {

    if (video) {
      var recentlyViewedProductPlayer = new Plyr(video, {
        controls: window.videoControls,
        ratio: this.aspect_ratio,
        fullscreen: {
          enabled: true,
          fallback: true,
          iosNative: true
        },
        storage: {
          enabled: false
        }
      });

      if (window.videoPlayers !== null) {
        window.videoPlayers.push(recentlyViewedProductPlayer);
        this.setupListeners();
      }

    }
  },
  setupRecommendedVideoPlayer: function() {
    var videosInRecommendedProducts = document.querySelectorAll('.product-recommendations [data-html5-video] video, .product-recommendations [data-youtube-video]');

    // Only run Plyr.setup if videosInRecommendedProducts exists
    if (videosInRecommendedProducts.length > 0) {
      window.videosInRecommendedProductsPlayer = Plyr.setup(videosInRecommendedProducts, {
        controls: window.videoControls,
        fullscreen: {
          enabled: true,
          fallback: true,
          iosNative: true
        },
        storage: {
          enabled: false
        }
      });
      if (window.videoPlayers !== null) {
        var combinedArray = window.videoPlayers.concat(window.videosInRecommendedProductsPlayer);
        window.videoPlayers = combinedArray;
      } else {
        window.videoPlayers = videosInRecommendedProductsPlayer;
      }
    }

    this.setupListeners();
  },
  setupListeners: function() {
    // Adds plyr video id to video wrapper
    $.each(window.videoPlayers, function(index, player) {
      var id = player.id || player.media.dataset.plyrVideoId;
      var $video;

      if (player.isHTML5) {
        $video = $(player.elements.wrapper).find('video');
        $video.attr('data-plyr-video-id', id);
      }
    })

    // When a video is playing, pause any other instances
    $.each(window.globalVideoPlayers, function(index, player) {
      player.on('play', function(event) {
        var instance = event.detail.plyr;
        $.each(window.globalVideoPlayers, function(index, player) {
          if (instance.id != player.id ) {
            player.pause();
          }
        })
      })
    })
  },
  enableVideoOnHover: function($thumbnail) {

    var $html5Video = $thumbnail.find('[data-html5-video]');
    var $youtubeVideo = $thumbnail.find('[data-youtube-video]');
    var videoID;

    if ($html5Video.length > 0) {
      videoID = $html5Video.find('[data-plyr-video-id]').data('plyr-video-id');
    } else if ($youtubeVideo.length > 0) {
      videoID = $youtubeVideo.find('iframe').attr('id');
    }

    if (videoID) {
      $.each(window.videoPlayers, function(index, player) {

        if (player.id == videoID || player.media.id == videoID) {
          player.toggleControls(false);
          player.muted = true;
          player.play();
        }
      })
    }
  },
  disableVideoOnHover: function($thumbnail) {
    var $html5Video = $thumbnail.find('[data-html5-video]');
    var $youtubeVideo = $thumbnail.find('[data-youtube-video]');
    var videoID;

    if ($html5Video.length > 0) {
      videoID = $html5Video.find('[data-plyr-video-id]').data('plyr-video-id');
    } else if ($youtubeVideo.length > 0) {
      videoID = $youtubeVideo.find('iframe').attr('id');
    }

    if (videoID) {
      $.each(window.videoPlayers, function(index, player) {
        if (player.id == videoID || player.media.id == videoID) {
          if (player.playing) {
            player.pause();
          }
        }
      })
    }
  }
}
